import { render } from "./Mars.vue?vue&type=template&id=0724fc8a"
import script from "./Mars.vue?vue&type=script&lang=js"
export * from "./Mars.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Study Material\\view-engines\\VUE\\planet-fact-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__